var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "padding" },
    [
      _c(
        "span",
        { staticClass: "m-10" },
        [
          _c(
            "b-select",
            {
              attrs: { placeholder: _vm.$t("pages.pickup_management.select") },
              model: {
                value: _vm.selectedGroup,
                callback: function ($$v) {
                  _vm.selectedGroup = $$v
                },
                expression: "selectedGroup",
              },
            },
            [
              _vm._l(_vm.collectGroups, function (grp) {
                return _c(
                  "option",
                  { key: grp.collectGroup, domProps: { value: grp } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          grp.collectGroup + " (" + grp.description + ")"
                        ) +
                        " "
                    ),
                  ]
                )
              }),
              _c("option", { domProps: { value: { collectGroup: "ALL" } } }, [
                _vm._v("All (Warning: Lot of data)"),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "b-tabs",
        { attrs: { type: "is-toggle" } },
        [
          _c(
            "b-tab-item",
            {
              attrs: {
                label: _vm.$t(
                  "pages.pickup_management.pickup_management.title"
                ),
              },
            },
            [
              _c("pickupManagement", {
                attrs: {
                  endusers: _vm.endusers,
                  "selected-group": _vm.selectedGroup,
                },
              }),
            ],
            1
          ),
          _c(
            "b-tab-item",
            {
              attrs: {
                label: _vm.$t("pages.pickup_management.calendar.title"),
              },
            },
            [
              _c("calendar", {
                attrs: {
                  "calendar-data": _vm.calendarData,
                  "selected-group": _vm.selectedGroup || {},
                },
              }),
            ],
            1
          ),
          _c(
            "b-tab-item",
            {
              attrs: {
                label: _vm.$t("pages.pickup_management.mail_observer.title"),
              },
            },
            [
              _c("mailObserver", {
                attrs: { "selected-group": _vm.selectedGroup || {} },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }